<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="20" viewBox="0 0 25 20">
    <g transform="translate(-263 -427)">
      <path
        d="M268.792,444.3a6.461,6.461,0,0,1-.983-.054c-1.1-.19-2.422-.508-2.861-1.275a1.133,1.133,0,0,1-.064-.991,9.671,9.671,0,0,0,.395-1.344,8.406,8.406,0,0,1,.348-1.194,8.57,8.57,0,0,0,.766-2.591v-3.855a.41.41,0,0,1,.145-.313.4.4,0,0,1,.333-.092,4.208,4.208,0,0,1,2.011.914.5.5,0,0,1,.064.066c.153.2.256.288.347.294.108.017.421-.079,1.1-.757a25.456,25.456,0,0,1,2.835-2.2c.2-.237.673-.765.673-.765a.412.412,0,0,1,.718.3,18.9,18.9,0,0,0,0,2.473,15.077,15.077,0,0,0,1.35,2.941A7.746,7.746,0,0,0,278,437.217a37.474,37.474,0,0,0,4.4,1.646c.312.044.842.081,1.355.117a8.327,8.327,0,0,1,1.779.219,2.384,2.384,0,0,1,1.085,1.462,1.44,1.44,0,0,1-.106,1.294,6.662,6.662,0,0,1-3.926,2.285c-1.14.083-4.16-.042-6.365-.134-.969-.039-1.736-.11-2.009-.071-.276,0-.9.04-1.664.088C271.059,444.218,269.719,444.3,268.792,444.3Zm-1.574-10.782V436.9a9.276,9.276,0,0,1-.83,2.865,7.7,7.7,0,0,0-.3,1.056,10.586,10.586,0,0,1-.425,1.448.308.308,0,0,0,.007.289c.139.242.646.588,2.285.871a35.166,35.166,0,0,0,4.544-.127c.783-.05,1.43-.09,1.715-.09h0c.284,0,1.06.032,2.041.072,2.062.086,5.176.216,6.229.14a5.806,5.806,0,0,0,3.38-1.976.759.759,0,0,0-.02-.5,1.869,1.869,0,0,0-.6-.978,10.108,10.108,0,0,0-1.552-.172c-.529-.037-1.077-.075-1.479-.137a37.771,37.771,0,0,1-4.559-1.7,8.557,8.557,0,0,1-2.294-1.553.393.393,0,0,1-.071-.087,16.008,16.008,0,0,1-1.472-3.206.425.425,0,0,1-.021-.1c-.032-.49-.047-.984-.043-1.478l-.016.012a24.559,24.559,0,0,0-2.778,2.149c-.717.715-1.233,1.013-1.722.98a1.286,1.286,0,0,1-.917-.575,3.369,3.369,0,0,0-1.1-.588Z"
        fill="#777"
      />
      <path
        d="M279.878,442.386c-1.393-.008-6.658-.456-8.291-.7s-5.651-.922-5.651-.922l.136-.813s4.009.671,5.639.92c1.571.238,6.835.686,8.165.694a21.192,21.192,0,0,0,3.835-.392,13.36,13.36,0,0,0,2.244-.858l.363.74a14.118,14.118,0,0,1-2.417.92A22.006,22.006,0,0,1,279.878,442.386Z"
        fill="#777"
      />
      <path
        d="M271.061,439.785l-2.491-2.655,6.009-4.085,1.594,3.3Zm-1.229-2.516,1.351,1.44,3.938-2.646-.868-1.8Z"
        fill="#777"
      />
      <rect
        width="1"
        height="4"
        transform="translate(263 443)"
        fill="#777"
      />
      <rect
        width="1"
        height="4"
        transform="translate(287 443)"
        fill="#777"
      />
      <rect
        width="24"
        height="1"
        transform="translate(264 446)"
        fill="#777"
      />
      <rect
        width="1"
        height="2"
        transform="translate(283 429.539)"
        fill="#777"
      />
      <rect
        width="1"
        height="3.001"
        transform="translate(283 432.007) rotate(-61.001)"
        fill="#777"
      />
      <path
        d="M283.5,436a4.5,4.5,0,1,1,4.5-4.5A4.506,4.506,0,0,1,283.5,436Zm0-8a3.5,3.5,0,1,0,3.5,3.5A3.5,3.5,0,0,0,283.5,428Z"
        fill="#777"
      />
    </g>
  </svg>
</template>
